import { HttpErrorResponse } from '@angular/common/http';
import { Location } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { startWith, map } from 'rxjs/operators';
import { NotificationType } from 'src/app/enum/notification-type.enum';
import { ErrorResponseMessage } from 'src/app/error-handler/error-response-message.model';
import { AddUser } from 'src/app/models/manageUsers/add-user.model';
import { MyDocsModel } from 'src/app/models/upload/mydocs.model';
import { UserManagementModel } from 'src/app/models/userManagementModel/usermang.model';
import { AuthGaurdService } from 'src/app/service/auth-gaurd.service';
import { CalendarService } from 'src/app/service/calendar.service';
import { CalendarModel } from 'src/app/models/config/calendar.model';
import { GlobalService } from 'src/app/service/global.service';
import { LoggerService } from 'src/app/service/logger.service';
import { ManageUserService } from 'src/app/service/manage-user.service';
import { ManageCodesService } from 'src/app/service/managecodes.service';
import { MyDocsService } from 'src/app/service/mydocs.service';
import { NotificationService } from 'src/app/service/notification.service';
import { UserManagementService } from 'src/app/service/user-management.service';
import { ApprovalFlowService } from 'src/app/admin-portal/approval-flow-models/approval-flow.service';
import { CommPlan } from 'src/app/models/commission/comm-plan.model';

@Component({
  selector: 'app-add-users',
  templateUrl: './add-users.component.html',
  styleUrls: ['./add-users.component.css']
})
export class AddUsersComponent implements OnInit {

  getAsOfDateData: AddUser[] =[];
  userModel = new AddUser();
  users: AddUser[] = [];
  userData: AddUser[] = [];
  assignedCorpsData: AddUser[] = [];
  supervisorData: AddUser[] = [];
  newUsers: AddUser[] = [];
  salesChnlsUserData: AddUser[] = [];
  selectedSalesChnl: AddUser[] = [];
  userTypes: string[] = [];
  comPlansUserData: AddUser[] = [];
  allComPlansUserData: AddUser[] = [];
  filteredComPlansUserData: AddUser[] = [];
  salesRepTypesList: AddUser[] = [];
  payrollCalendarData: AddUser[] = [];
  salesRepTypes: string[] = [];
  corps: number[] = [];
  hidefields: boolean = true;
  hidependingfields: boolean = true;
  value: string | undefined;
  otherFields: boolean = true;
  repUserType: boolean = true;
  managerUserType: boolean = false;
  otherUserType: boolean = false;
  salesChannelAdmin: boolean = false;
  selectedCommissionPlans: number[] = [];
  header: string = 'Update User';
  changeColor: boolean[] = [];
  rowcolor: string = 'tablerow';
  sub: any;
  page: string = '';
  returnTo: string = '';
  supervisorNamesSet = new Set<string>();
  ascCorps: any = [];
  isAscCorp: boolean = true;
  userDocData: MyDocsModel[];
  docName: string = '';
  roles: UserManagementModel[];
  payrollCalender: string[];
  effDate: Date;
  @Input() placeholder: string = 'Select Employee';
  filteredCommPlans: Observable<AddUser[]> | undefined;
  selectControl = new FormControl();
  selectedCommplans: AddUser[] = [];
  selectedCommplanIds: string = '';
  empid: string = '';
  org_effective_date: Date = null;
  org_user_role: string = null; 
  org_comm_plan_id: any = null; 
  org_sales_channel: string = null; 
  org_sales_rep_id: string = null;

  // Calendar lock/unlock properties
  calendarData: CalendarModel[] = [];
  isFormLocked: boolean = false;
  showLockedPeriodAlert: boolean = false;

  filteredSalesChannelValues: Observable<AddUser[]> | undefined;
  controlSc = new FormControl();
  filteredSalesRepTypeValues: Observable<string[]> | undefined;
  controlSrt = new FormControl();
  filteredSupValues: Observable<AddUser[]> | undefined;
  controlSup = new FormControl();
  pending: boolean;
  roleNmaes: string[] = [];
  //addNew: boolean = false;
  isAccessDisabled: boolean = false;
  isChecked: boolean = false;
  checkboxChecked: string = "";
  asOfDateStstus: string = "";
  isSalesRepIdInvalid: boolean = false;

  isCorrectionMode: boolean = false;
  correctionButtonText: string = "Correction";
  correctionButtonClass: string = "btn btn-primary";
  lockedCycleMsgVisible = false;
  lockedCycleMsg = "The cycle is closed — can we create the record with new Effective date?";
  timelineCurrentRecords: AddUser[] = [];
  timelinePastRecords: AddUser[] = [];
  timelineFutureRecords: AddUser[] = [];
  selectedTimelineRecordKey: string = '';
  selectedAsOfUser: AddUser | null = null;
  isTimelineCollapsed: boolean = false;

  //page: number;
  constructor(private manageCodesService: ManageCodesService, private router: Router,
    private route: ActivatedRoute,
    private logger: LoggerService,
    private manageUserService: ManageUserService,
    private myDocsService: MyDocsService,
    private notificationService: NotificationService, private authGaurdService: AuthGaurdService,
    private usermanagementService: UserManagementService, private globalService: GlobalService,
     private calendarService: CalendarService, private location: Location,
     private approvalFlowService: ApprovalFlowService) { }

  ngOnInit(): void {
    this.asOfDateStstus = "";
    this.filterSupervisors();
    this.getPayrollCalendar();

    this.route.queryParams.subscribe(params => {
      this.page = params['page'];
      this.returnTo = params['returnTo'] || '';
      console.log("Page Name: " + this.page);

      if (this.page === 'pending-users') {
        this.hidependingfields = false;
        this.pending = true;
      } else if (this.page === 'newUser') {
        this.pending = true;
        // this.addNew = true;
      } else if (this.page === 'updatePersonnelUser') {
        this.userModel = this.manageUserService.selectedUserModel;
        this.pending = false;
      } else {
        // this.addNew = true;
      }

    }, (errorResponse: HttpErrorResponse) => {
      var msg: any;
      msg = errorResponse;
      this.notificationService.sendNotification(NotificationType.ERROR, msg);
    });
    this.isAccessDisabled = this.globalService._permissionCheck('manage-users');
    if (this.isAccessDisabled) {
      this.notificationService.notify(NotificationType.WARNING, "Edit Permission Has Disabled Please Contact To Adminstrator");
    }
    this.selectedCommplans = [];
    this.getPrePopulatedUserData();
    this.filterCommPlans();
    this.getAsOfDate();
   // this.loadCalendarData();
  }


  getAsOfDate() {
    if (!this.userModel || !this.userModel.employeeId || this.page === 'newUser') {
      this.getAsOfDateData = [];
      this.timelineCurrentRecords = [];
      this.timelinePastRecords = [];
      this.timelineFutureRecords = [];
      return;
    }

    this.manageUserService.getCompleteEmployeeHistory(this.userModel.employeeId, true)
      .subscribe((historyData: AddUser[]) => {
        const timelineData = (historyData || [])
          .filter(record => !!record?.effective_date)
          .map(record => ({
            ...record,
            profileStatus: record.profileStatus || this.getProfileStatus(record)
          }))
          .sort((a, b) =>
            (this.toDateOnly(b.effective_date)?.getTime() || 0) - (this.toDateOnly(a.effective_date)?.getTime() || 0)
          );

        const defaultDate = this.userModel.getasofdate || this.userModel.effective_date;
        const selected = timelineData.find(record =>
          this.toIsoDate(record.effective_date) === this.toIsoDate(defaultDate) &&
          (record.id || '') === (this.userModel.id || '')
        ) || timelineData.find(record =>
          this.toIsoDate(record.effective_date) === this.toIsoDate(defaultDate)
        ) || timelineData[0];

        this.getAsOfDateData = timelineData;
        this.buildTimelineGroups(timelineData, selected);

        if (selected) {
          this.selectedTimelineRecordKey = this.timelineRecordKey(selected);
          this.userModel.getasofdate = selected.effective_date;
        }
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  onChangeAsOfDt() {
    this.asOfDateStstus = "true";
    this.manageUserService.getUserByAsOfDt(this.userModel.employeeId, this.userModel.getasofdate, this.userModel.id)
      .subscribe((data: AddUser) => {
        // if (!data) {
        //   console.log("Inside IF");
        // }else{
        //   console.log("Inside ELSE");
        // }

        if (data == null || data == undefined || data.toString() == "") {
          this.notificationService.sendNotification(NotificationType.ERROR, 'No Data Found!');
        } else {
          const selectedAsOfData = Array.isArray(data) ? data[0] : data;
          this.selectedAsOfUser = selectedAsOfData;
            // Update original user role when as-of date changes
          this.org_user_role = selectedAsOfData.userRole;
          this.org_comm_plan_id = selectedAsOfData.comm_plan_id;
          this.org_sales_channel = selectedAsOfData.sales_rep_channel;
          this.org_sales_rep_id = selectedAsOfData.sales_rep_id;
          this.getPrePopulatedUserData();
          this.selectedTimelineRecordKey = this.timelineRecordKey(this.userModel);
           // Check lock status for the new effective date
         // this.checkFormLockStatus();
        }
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  private toDateOnly(dateInput: any): Date | null {
    if (!dateInput) {
      return null;
    }

    // Calendar dates must not be shifted by timezone.
    // "2026-08-31" / "2026-08-31T00:00:00.000Z" should stay Aug 31, not become Aug 30 in US timezones.
    if (typeof dateInput === 'string') {
      const trimmed = dateInput.trim();
      const isoDay = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (isoDay) {
        return new Date(Number(isoDay[1]), Number(isoDay[2]) - 1, Number(isoDay[3]));
      }
      const usDay = trimmed.match(/^(\d{2})-(\d{2})-(\d{4})/);
      if (usDay) {
        return new Date(Number(usDay[3]), Number(usDay[1]) - 1, Number(usDay[2]));
      }
    }

    const parsed = dateInput instanceof Date ? dateInput : new Date(dateInput);
    if (isNaN(parsed.getTime())) {
      return null;
    }

    // JSON/JDBC date-only values are typically midnight UTC for that calendar day
    return new Date(parsed.getUTCFullYear(), parsed.getUTCMonth(), parsed.getUTCDate());
  }

  private toIsoDate(dateInput: any): string {
    const date = this.toDateOnly(dateInput);
    if (!date) {
      return '';
    }
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  private getMonthStart(baseDate: Date = new Date()): Date {
    return new Date(baseDate.getFullYear(), baseDate.getMonth(), 1);
  }

  private normalizeEffectiveDateToMonthStart(dateInput: any): Date | null {
    const date = this.toDateOnly(dateInput);
    if (!date) {
      return null;
    }
    return this.getMonthStart(date);
  }

  private resolvePendingEffectiveDateSource(): any {
    return this.userModel?.effective_date
      || this.manageUserService.selectedUserModel?.effective_date
      || this.userModel?.getasofdate
      || this.manageUserService.selectedUserModel?.getasofdate
      || this.userModel?.edate
      || this.manageUserService.selectedUserModel?.edate;
  }

  private applyPendingEffectiveDateMonthStart(): void {
    if (this.page !== 'pending-users') {
      return;
    }

    const sourceDate = this.resolvePendingEffectiveDateSource();
    if (!sourceDate) {
      return;
    }

    const normalized = this.normalizeEffectiveDateToMonthStart(sourceDate);
    if (!normalized) {
      return;
    }

    const monthStartIso = this.toIsoDate(normalized);
    this.userModel.effective_date = monthStartIso;
    if (this.asOfDateStstus !== 'true') {
      this.userModel.getasofdate = monthStartIso;
    }
  }

  private getProfileStatus(record: AddUser): string {
    const today = this.toDateOnly(new Date());
    const effectiveDate = this.toDateOnly(record?.effective_date);
    const softTermDate = this.toDateOnly(record?.soft_termination_date);
    if (softTermDate && softTermDate <= today) {
      return 'inactive';
    }
    if (effectiveDate && effectiveDate > today) {
      return 'pending';
    }
    return 'complete';
  }

  private timelineRecordKey(record: AddUser): string {
    return `${record?.id || 'NA'}|${this.toIsoDate(record?.effective_date)}`;
  }

  private buildTimelineGroups(records: AddUser[], selectedRecord?: AddUser): void {
    const monthStart = this.getMonthStart(new Date());
    const monthEnd = new Date(monthStart.getFullYear(), monthStart.getMonth() + 1, 0);

    this.timelineCurrentRecords = records.filter(record => {
      const effectiveDate = this.toDateOnly(record.effective_date);
      if (!effectiveDate) {
        return false;
      }
      return effectiveDate >= monthStart && effectiveDate <= monthEnd;
    });

    this.timelinePastRecords = records.filter(record => {
      const effectiveDate = this.toDateOnly(record.effective_date);
      return !!effectiveDate && effectiveDate < monthStart;
    });

    this.timelineFutureRecords = records.filter(record => {
      const effectiveDate = this.toDateOnly(record.effective_date);
      return !!effectiveDate && effectiveDate > monthEnd;
    });

    // Keep selected/landed record in Current Month section per UX request.
    if (selectedRecord) {
      const selectedKey = this.timelineRecordKey(selectedRecord);
      const alreadyInCurrent = this.timelineCurrentRecords.some(record => this.timelineRecordKey(record) === selectedKey);

      if (!alreadyInCurrent) {
        const pastIndex = this.timelinePastRecords.findIndex(record => this.timelineRecordKey(record) === selectedKey);
        if (pastIndex > -1) {
          const [moved] = this.timelinePastRecords.splice(pastIndex, 1);
          this.timelineCurrentRecords.unshift(moved);
          return;
        }

        const futureIndex = this.timelineFutureRecords.findIndex(record => this.timelineRecordKey(record) === selectedKey);
        if (futureIndex > -1) {
          const [moved] = this.timelineFutureRecords.splice(futureIndex, 1);
          this.timelineCurrentRecords.unshift(moved);
        }
      }
    }
  }

  timelineCardStatusLabel(record: AddUser): string {
    if (record?.profileStatus === 'inactive') {
      return 'Inactive';
    }
    if (record?.profileStatus === 'pending') {
      return 'Future';
    }
    return 'Active';
  }

  isTimelineCardSelected(record: AddUser): boolean {
    return this.timelineRecordKey(record) === this.selectedTimelineRecordKey;
  }

  selectTimelineRecord(record: AddUser): void {
    this.selectedTimelineRecordKey = this.timelineRecordKey(record);
    this.userModel.getasofdate = record.effective_date;
    this.userModel.id = record.id;
    this.onChangeAsOfDt();
  }

  toggleTimelinePanel(): void {
    this.isTimelineCollapsed = !this.isTimelineCollapsed;
  }

  getPrePopulatedUserData() {
    this.selectedCommplans = [];
    this.newUsers = [];
    this.effDate = this.manageUserService.selectedUserModel.effective_date;

    const hadCachedDropdowns = this.hasCachedPrePopulatedData();
    if (hadCachedDropdowns) {
      this.hydrateDropdownsFromServiceCache();
    }

    this.manageUserService.getPrePopulatedUserData()
      .subscribe((data: AddUser[]) => {
        this.userData = data;
        if (!hadCachedDropdowns) {
          this.parsePrePopulatedUserData(data);
          this.syncDropdownsToService();
        }
        this.applySelectedUserModel();
        this.onSalesChannelChange();
        this.filterSalesChannels();
        this.filterSalesRepTypes();
        this.getComDoc();
        this.getRoles();
        this.userModel.corps = [];
        this.corps = [];
        this.supervisorNamesSet = this.manageUserService.supervisorNamesSet;
        this.getCorps(this.userModel.id, this.userModel.effective_date);
        this.empid = this.userData?.length > 0 ? this.userData[0].employeeId : null;
        if (this.empid === '' || this.empid === null) {
          this.empid = this.userModel.employeeId;
        }
        this.selectedUserType(this.userModel.userRole);
        this.hydrateSelectedCommissionPlans();
        this.getAsscCommPlanIds(this.userModel.employeeId);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  private hasCachedPrePopulatedData(): boolean {
    return (this.manageUserService.salesChnlsUserData?.length ?? 0) > 0
      && (this.manageUserService.comPlansUserData?.length ?? 0) > 0;
  }

  /** Keep one entry per comm_plan_id when building dropdown lists. */
  private uniqueCommPlansById(plans: AddUser[]): AddUser[] {
    const byId = new Map<number, AddUser>();
    for (const plan of plans ?? []) {
      if (plan?.comm_plan_id != null) {
        byId.set(Number(plan.comm_plan_id), plan);
      }
    }
    return Array.from(byId.values());
  }

  private hydrateDropdownsFromServiceCache(): void {
    this.salesChnlsUserData = this.manageUserService.salesChnlsUserData;
    this.userTypes = this.manageUserService.userTypes;
    const cachedPlans = this.manageUserService.allComPlansUserData?.length
      ? this.manageUserService.allComPlansUserData
      : this.manageUserService.comPlansUserData;
    this.allComPlansUserData = this.uniqueCommPlansById(cachedPlans);
    this.comPlansUserData = [...this.allComPlansUserData].sort((a, b) =>
      (a.commission_plan < b.commission_plan) ? -1 : 1
    );
    this.salesRepTypes = this.manageUserService.salesRepTypes;
    this.payrollCalender = this.manageUserService.payrollCalender;
  }

  private parsePrePopulatedUserData(data: AddUser[]): void {
    this.salesChnlsUserData = [];
    this.userTypes = [];
    this.allComPlansUserData = [];
    this.comPlansUserData = [];
    this.salesRepTypes = [];
    this.payrollCalender = [];

    for (const userInfo of data) {
      if (userInfo.commission_plan != null) {
        this.allComPlansUserData.push(userInfo);
      } else if (userInfo.sales_rep_channel != null && userInfo.sales_rep_channel_desc != null) {
        this.salesChnlsUserData.push(userInfo);
      } else if (userInfo.user_type != null) {
        this.userTypes.push(userInfo.user_type);
      } else if (userInfo.sales_rep_type != null) {
        this.salesRepTypes.push(userInfo.sales_rep_type);
      } else if (userInfo.calendar_type != null) {
        this.payrollCalender.push(userInfo.calendar_type);
      }
    }

    if (this.userTypes.length > 1) {
      this.userTypes.sort((a, b) => a.localeCompare(b));
    }
    if (this.salesRepTypes.length > 1) {
      this.salesRepTypes.sort((a, b) => a.localeCompare(b));
    }
    if (this.payrollCalender.length > 1) {
      this.payrollCalender.sort((a, b) => a.localeCompare(b));
    }
    this.allComPlansUserData = this.uniqueCommPlansById(this.allComPlansUserData);
    if (this.allComPlansUserData.length > 1) {
      this.allComPlansUserData.sort((a, b) => (a.commission_plan < b.commission_plan) ? -1 : 1);
    }
    this.comPlansUserData = [...this.allComPlansUserData];
  }

  private syncDropdownsToService(): void {
    this.manageUserService.salesChnlsUserData = this.salesChnlsUserData;
    this.manageUserService.userTypes = this.userTypes;
    this.manageUserService.allComPlansUserData = this.allComPlansUserData;
    this.manageUserService.comPlansUserData = this.comPlansUserData;
    this.manageUserService.salesRepTypes = this.salesRepTypes;
    this.manageUserService.payrollCalender = this.payrollCalender;
  }

  private applySelectedUserModel(): void {
    if (this.page === 'newUser') {
      this.userModel = new AddUser();
    } else if (this.asOfDateStstus === 'true') {
      this.userModel = this.selectedAsOfUser ? this.selectedAsOfUser : this.manageUserService.selectedUserModel;
    } else {
      this.userModel = this.manageUserService.selectedUserModel;
    }
    this.applyPendingEffectiveDateMonthStart();
    this.userModel.getasofdate = this.userModel.getasofdate || this.userModel.effective_date;

    this.org_effective_date = this.userModel.effective_date;
    this.org_user_role = this.userModel.userRole;
    this.org_comm_plan_id = this.userModel.comm_plan_id;
    this.org_sales_channel = this.userModel.sales_rep_channel;
    this.org_sales_rep_id = this.userModel.sales_rep_id;

    if (this.asOfDateStstus === 'true') {
      this.userModel.commissionable = this.selectedAsOfUser?.commissionable || this.userModel.commissionable || 'Y';
    } else {
      this.userModel.commissionable = this.manageUserService.selectedUserModel?.commissionable || this.userModel.commissionable || 'Y';
    }
  }

  onSalesChannelChange(): void {
    const selectedChannel = this.salesChnlsUserData.find(
      channel => channel.sales_rep_channel === this.userModel.sales_rep_channel
    );
    if (selectedChannel) {
      this.userModel.sales_rep_channel_desc = selectedChannel.sales_rep_channel_desc;
    }
    this.filterCommissionPlansBySalesChannel();
  }

  private filterCommissionPlansBySalesChannel(): void {
    const source = this.uniqueCommPlansById(this.allComPlansUserData);

    if (!this.userModel.sales_rep_channel) {
      const allPlans = source.slice()
        .sort((a, b) => (a.commission_plan < b.commission_plan) ? -1 : 1);
      this.filteredComPlansUserData = allPlans;
      this.comPlansUserData = allPlans;
      return;
    }

    const selectedChannel = this.salesChnlsUserData.find(
      channel => channel.sales_rep_channel === this.userModel.sales_rep_channel
    );
    const channelDesc = selectedChannel?.sales_rep_channel_desc ?? this.userModel.sales_rep_channel_desc;

    const filteredPlans = source
      .filter(plan => this.planMatchesSalesChannel(plan, this.userModel.sales_rep_channel, channelDesc))
      .sort((a, b) => (a.commission_plan < b.commission_plan) ? -1 : 1);

    this.filteredComPlansUserData = filteredPlans;
    this.comPlansUserData = filteredPlans;

    if (this.userModel.userRole !== 'Sales Channel Admin'
      && this.userModel.comm_plan_id != null
      && !this.filteredComPlansUserData.some(plan => Number(plan.comm_plan_id) === Number(this.userModel.comm_plan_id))) {
      this.userModel.comm_plan_id = null;
    }
    // Do not drop assigned multi-plans for Sales Channel Admin when channel filter runs
    if (this.selectedCommissionPlans?.length && this.userModel.userRole !== 'Sales Channel Admin') {
      this.selectedCommissionPlans = this.selectedCommissionPlans.filter(planId =>
        this.comPlansUserData.some(plan => Number(plan.comm_plan_id) === Number(planId))
      );
    } else if (this.userModel.userRole === 'Sales Channel Admin') {
      this.ensureSelectedPlansVisibleForSca();
    }
  }

  private hydrateSelectedCommissionPlans(): void {
    // Multi-select commission plans apply only to Sales Channel Admin
    if (this.userModel.userRole !== 'Sales Channel Admin') {
      this.selectedCommissionPlans = [];
      return;
    }

    const multiPlanIds = this.userModel.commplan_id || this.userModel.commPlanId;
    if (multiPlanIds) {
      this.selectedCommissionPlans = String(multiPlanIds)
        .split(',')
        .map(id => Number(String(id).trim()))
        .filter(id => !Number.isNaN(id));
      this.ensureSelectedPlansVisibleForSca();
      return;
    }

    if (this.userModel.comm_plan_id != null) {
      this.selectedCommissionPlans = [Number(this.userModel.comm_plan_id)];
      this.ensureSelectedPlansVisibleForSca();
      return;
    }

    this.selectedCommissionPlans = [];
  }

  /** Keep assigned SCA plans visible/checked even if channel filter would hide them. */
  private ensureSelectedPlansVisibleForSca(): void {
    if (this.userModel.userRole !== 'Sales Channel Admin' || !this.selectedCommissionPlans?.length) {
      return;
    }
    for (const planId of this.selectedCommissionPlans) {
      const alreadyVisible = this.comPlansUserData.some(
        plan => Number(plan.comm_plan_id) === Number(planId)
      );
      if (alreadyVisible) {
        continue;
      }
      const fromAll = this.allComPlansUserData.find(
        plan => Number(plan.comm_plan_id) === Number(planId)
      );
      if (fromAll) {
        this.comPlansUserData = [...this.comPlansUserData, fromAll]
          .sort((a, b) => (a.commission_plan < b.commission_plan) ? -1 : 1);
      }
    }
  }

  prepareCommissionPlanData(): void {
    if (this.salesChannelAdmin && this.selectedCommissionPlans.length > 0) {
      this.userModel.commplan_id = this.selectedCommissionPlans.join(',');
      // Keep a single primary plan id for backends that still expect comm_plan_id
      this.userModel.comm_plan_id = this.selectedCommissionPlans[0];
      this.userModel.commPlanId = null;
    } else if (!this.salesChannelAdmin && this.userModel.comm_plan_id) {
      this.userModel.commplan_id = null;
    }
  }

  isCommissionPlanSelected(planId: number): boolean {
    return this.selectedCommissionPlans?.some(id => Number(id) === Number(planId));
  }

  toggleCommissionPlan(planId: number, event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    const normalizedPlanId = Number(planId);
    if (Number.isNaN(normalizedPlanId)) {
      return;
    }

    if (checked) {
      if (!this.isCommissionPlanSelected(normalizedPlanId)) {
        this.selectedCommissionPlans = [...this.selectedCommissionPlans, normalizedPlanId];
      }
    } else {
      this.selectedCommissionPlans = this.selectedCommissionPlans.filter(
        id => Number(id) !== normalizedPlanId
      );
    }
  }

  private requiresExactChannelMatch(channelCode: string, channelDesc: string): boolean {
    const combined = `${channelCode || ''} ${channelDesc || ''}`.toLowerCase();
    return combined.includes('direct sales') && combined.includes('bpo');
  }

  private channelValuesMatchExactly(left: string, right: string): boolean {
    return !!left && !!right && left === right;
  }

  private planMatchesSalesChannel(plan: AddUser, channelCode: string, channelDesc: string): boolean {
    const planChannel = this._normalizeValue(plan.sales_rep_channel || '');
    const planDesc = this._normalizeValue(plan.sales_channel_desc || '');
    const channelToken = this._normalizeValue(channelCode || '');
    const descToken = this._normalizeValue(channelDesc || '');

    if (this.requiresExactChannelMatch(channelCode, channelDesc)) {
      return this.channelValuesMatchExactly(planChannel, channelToken)
        || this.channelValuesMatchExactly(planDesc, descToken)
        || this.channelValuesMatchExactly(planChannel, descToken)
        || this.channelValuesMatchExactly(planDesc, channelToken);
    }

    const planValues = [planChannel, planDesc].filter(value => value.length > 0);
    const matchTokens = [channelToken, descToken].filter(value => value.length > 0);

    for (const token of matchTokens) {
      for (const planValue of planValues) {
        if (planValue === token || planValue.startsWith(token) || token.startsWith(planValue)) {
          return true;
        }
      }
    }
    return false;
  }

  getPayrollCalendar() {
    this.manageUserService.getPayrollCalendar()
      .subscribe((data: any) => {
        this.payrollCalendarData = data;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  private getAsscCommPlanIds(empId: string) {
    //console.log(empId);
    this.manageUserService.filterByEmpId(empId)
      .subscribe((userDataList: AddUser[]) => {
        if (userDataList == null || userDataList == undefined || userDataList.toString() == "") {
          // this.notificationService.sendNotification(NotificationType.ERROR, 'No data Found!');
        } else {
          for (let user of userDataList) {
            this.comPlansUserData.forEach((value: any, index: any) => {
              //if (value.comm_plan_id == user.comm_plan_id) this.comPlansUserData.splice(index, 1);
            });
          }
        }

        // console.log(this.userModel.commission_plan);

      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  selectedUserType(event: any) {
    //console.log(event.target.value);
    if (event?.target)
      this.value = event.target.value;
    else
      this.value = event;
    if (this.value === 'salesRep' || this.value === 'Sales Representative' || this.value === 'No Access') {
      this.hidefields = true;
      this.otherFields = true;
      this.repUserType = true;
      this.managerUserType = false;
      this.otherUserType = false;
      this.salesChannelAdmin=false;
      //this.header = 'Create Sales  Representative'
    }
    else if (this.value === 'SUPERVISOR_MANAGER' || this.value === 'Supervisor') {
      this.hidefields = true;
      this.otherFields = true;
      this.managerUserType = true;
      this.otherUserType = false;
      this.repUserType = false;
      this.salesChannelAdmin=false;
      // this.header = 'Create Supervisor/Manager'
    }
    else if (this.value === 'Sales Channel Admin') {
      this.hidefields = true;
      this.otherFields = false;
      this.otherUserType = true;
      this.managerUserType = false;
      this.repUserType = false;
      this.salesChannelAdmin = true;
      //this.header = 'Add Sales Channel Admin'
    }
    else {
      this.hidefields = true;
      this.otherFields = false;
      this.otherUserType = true;
      this.managerUserType = false;
      this.repUserType = false;
      //this.header = 'Add Manager/Admin User'
    }
    this.applyPendingEffectiveDateMonthStart();
  }

  public getComDoc() {
    this.myDocsService.filterUserDocByEmp(this.userModel.employeeId).subscribe(
      (response: MyDocsModel[]) => {
        //this.dataSource.data = response as MyDocsModel[];
        this.userDocData = response;
        //console.log("=======", this.userDocData);
        if (this.userDocData.length > 0) {
          for (let userDoc of this.userDocData) {
            this.docName = this.docName + userDoc.doc_name + ' ,';
          }
        }
        this.userModel.userDoc = this.docName;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }

    )
  }

  public getRoles() {
    this.roleNmaes = [];
    this.usermanagementService.getRoles().subscribe(
      (response: UserManagementModel[]) => {
        this.roles = response;
        for (let role of this.roles) {
          this.roleNmaes.push(role.role_name);
          if (this.roleNmaes.length > 1) {
            this.roleNmaes.sort((a, b) =>
              a.localeCompare(b));
          }
        }
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )
  }

  getCorps(id: string, edate: Date) {
    this.manageCodesService.getCorps()
      .subscribe((data: any) => {
        if (data.length > 0) {
          this.userData = data;

          for (let corpdata of this.userData) {
            if (corpdata.corp) {
              this.corps.push(corpdata.corp);
            }
          }

          this.getAssignedCorps(id, edate);
        }
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  getAssignedCorps(id: string, edate: Date) {
    this.manageCodesService.getAssignedCorps(id, edate)
      .subscribe((data: any) => {

        if (data == null || data == undefined || data.toString() == "") {
          // this.notificationService.sendNotification(NotificationType.ERROR, 'No data Found!');
        } else {
          this.assignedCorpsData = data;
          this.userModel.assc_corps = this.assignedCorpsData[0].assc_corps;

          this.selectedCorps();
        }

      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  selectedCorps() {
    this.userModel.changeColor = [];
    this.userModel.corps = [];
    if (this.userModel.assc_corps) {
      this.ascCorps = this.userModel.assc_corps.split(',');
      this.ascCorps.forEach((value: any, index: any) => {
        var numeric = Number(value);
        this.userModel.corps.push(numeric);

      });
    }
    // color change
    for (let corp of this.corps) {
      this.isAscCorp = true;
      if (this.userModel.assc_corps) {
        this.ascCorps = this.userModel.assc_corps.split(',');
        this.ascCorps.forEach((value: any, index: any) => {
          var numeric = Number(value);

          if (numeric === corp) {
            this.isAscCorp = false;
            this.userModel.changeColor.push(true);
          }

        });
      }
      if (this.isAscCorp) {
        this.userModel.changeColor.push(false);
      }
    }
  }

  checkAll() {
    this.userModel.changeColor = [];
    this.userModel.corps = [];
    for (let corp of this.corps) {
      this.userModel.changeColor.push(true);
      this.userModel.corps.push(corp);
    }
  }

  uncheckAll() {
    this.userModel.changeColor = [];
    this.userModel.corps = [];
  }

  checkValue1(event: any) {
    this.isChecked = event;
    //console.log(this.isChecked);
  }

  checkValue(event: any) {
    this.isChecked = event.checked;
    console.log(this.isChecked);

    // if (this.isChecked) {
    //   alert("New COMPAS ID is only needed if the employee needs to get paid for 2 commission plans in the same month or the User Role is changed.");
    // }

  }

  saveUser() {
    // console.log("Inside saveUser = " + JSON.stringify(this.userModel));

 // Check if Sales Rep ID has been changed
    const salesRepIdChanged = this.org_sales_rep_id !== this.userModel.sales_rep_id;
    console.log('Sales Rep ID changed: ' + salesRepIdChanged + ', Original: ' + this.org_sales_rep_id + ', Current: ' + this.userModel.sales_rep_id);

    // Only validate if Sales Rep ID has been changed AND it's not empty/NA
    if (salesRepIdChanged && 
        this.userModel.sales_rep_id && 
        this.userModel.sales_rep_id.trim() !== '' && 
        this.userModel.sales_rep_id !== 'NA') {
      
      // Get current user's sc_emp_id (empty for new users)
      const currentScEmpId = this.userModel.id || '';
      
      // Perform validation before allowing save
      console.log('Validating Sales Rep ID before save: ' + this.userModel.sales_rep_id + ', currentScEmpId: ' + currentScEmpId);
      
      this.manageUserService.validateSalesRepId(this.userModel.sales_rep_id, currentScEmpId).subscribe(
        (isActive: boolean) => {
          console.log('Save validation result: ' + isActive);
          if (isActive) {
            // Sales Rep ID is already assigned to an active user - STOP
            this.sendNotification(NotificationType.ERROR, 'The Sales Rep ID is assigned to an Active user, please use a different Sales Rep ID');
            return; // Stop here, don't continue to saveAfterValidation
          } else {
            // Sales Rep ID is available - proceed with save
            this.proceedWithSave();
          }
        }, (errorResponse: HttpErrorResponse) => {
          console.error('Error validating Sales Rep ID during save:', errorResponse);
          // On error, allow save to proceed
          this.proceedWithSave();
        }
      );
    } else {
      // No Sales Rep ID or it's NA - proceed directly
      this.proceedWithSave();
    }
  }

  private proceedWithSave() {
    console.log('proceedWithSave() called');


    if (this.userModel.userRole) {
      if (this.userModel.userRole === "ADMIN" || this.userModel.userRole === "Sales Channel Admin") {

        if (!this.userModel.first_name) {
          this.sendNotification(NotificationType.ERROR, `Please enter First Name`);
        } else if (!this.userModel.last_name) {
          this.sendNotification(NotificationType.ERROR, `Please enter Last Name`);
        } else if (!this.userModel.user_type) {
          this.sendNotification(NotificationType.ERROR, `Please select User Type`);
        } else if (this.page === 'pending-users' && !this.userModel.effective_date) {
          this.sendNotification(NotificationType.ERROR, `Please select Effective Date`);
        } else if (this.userModel.userRole === "Sales Channel Admin" && this.selectedCommissionPlans.length === 0) {
          this.sendNotification(NotificationType.ERROR, `Please select at least one Commission Plan`);
        } else {
          this.saveAfterValidate();
        }

      } else if (this.userModel.userRole === "Supervisor") {
        if (!this.userModel.first_name) {
          this.sendNotification(NotificationType.ERROR, `Please enter First Name`);
        } else if (!this.userModel.last_name) {
          this.sendNotification(NotificationType.ERROR, `Please enter Last Name`);
        } else if (!this.userModel.effective_date) {
          this.sendNotification(NotificationType.ERROR, `Please select Effective Date`);
        } else if (!this.userModel.userRole) {
          this.sendNotification(NotificationType.ERROR, `Please select User Role`);
        } else if (!this.userModel.user_type) {
          this.sendNotification(NotificationType.ERROR, `Please select User Type`);
        } else if (!this.userModel.calendar_type) {
          this.sendNotification(NotificationType.ERROR, `Please select Payroll Calendar`);
        } else if (!this.userModel.supervisor_name) {
          this.sendNotification(NotificationType.ERROR, `Please select Supervisor`);
        } else if (!this.userModel.sales_rep_channel_desc) {
          this.sendNotification(NotificationType.ERROR, `Please select Sales Channel`);
        } else if (!this.userModel.comm_plan_id) {
          this.sendNotification(NotificationType.ERROR, `Please select Commission Plan`);
        } else if (!this.userModel.commissionable) {
          this.sendNotification(NotificationType.ERROR, `Please select Commissionable`);
        } else {
          this.saveAfterValidate();
        }
      } else {
        if (!this.userModel.first_name) {
          this.sendNotification(NotificationType.ERROR, `Please enter First Name`);
        } else if (!this.userModel.last_name) {
          this.sendNotification(NotificationType.ERROR, `Please enter Last Name`);
        } else if (!this.userModel.effective_date) {
          this.sendNotification(NotificationType.ERROR, `Please select Effective Date`);
        } else if (!this.userModel.sales_rep_id) {
          this.sendNotification(NotificationType.ERROR, `Please enter Sales Rep ID`);
        } else if (!this.userModel.userRole) {
          this.sendNotification(NotificationType.ERROR, `Please select User Role`);
        } else if (!this.userModel.user_type) {
          this.sendNotification(NotificationType.ERROR, `Please select User Type`);
        } else if (!this.userModel.calendar_type) {
          this.sendNotification(NotificationType.ERROR, `Please select Payroll Calendar`);
        } else if (!this.userModel.supervisor_name) {
          this.sendNotification(NotificationType.ERROR, `Please select Supervisor`);
        } else if (!this.userModel.sales_rep_channel_desc) {
          this.sendNotification(NotificationType.ERROR, `Please select Sales Channel`);
        } else if (!this.userModel.comm_plan_id) {
          this.sendNotification(NotificationType.ERROR, `Please select Commission Plan`);
        } else if (!this.userModel.commissionable) {
          this.sendNotification(NotificationType.ERROR, `Please select Commissionable`);
        } else {
          this.saveAfterValidate();
        }
      }
    } else {
      this.sendNotification(NotificationType.ERROR, `Please select User Role`);
    }


  }

//   onUpdate(): void {
//   const original = new Date(this.org_effective_date).toISOString().split('T')[0];
//   const current = new Date(this.userModel.effective_date).toISOString().split('T')[0];
  
//   // Check if user role has changed - only for add-user page (not pending-users)
//   if (this.org_user_role && this.userModel.userRole && 
//       this.org_user_role !== this.userModel.userRole && 
//       this.page !== 'pending-users') {
//         // Check if commission plan has been updated (must be different from original)
//     const commissionPlanUpdated = this.org_comm_plan_id !== this.userModel.comm_plan_id;
    
//     // Both conditions must be met: commission plan updated AND Generate New COMPAS ID checked
//     if (!commissionPlanUpdated && !this.isChecked) {
//       alert("User role has changed. Please update the commission plan and check 'Generate New COMPAS ID' before proceeding.");
//       return;
//     } else if (!commissionPlanUpdated) {
//       alert("User role has changed. Please update the commission plan before proceeding.");
//       return;
//     } else if (!this.isChecked) {
//       alert("User role has changed. Please check 'Generate New COMPAS ID' before proceeding.");
//       return;
//     }
//   }

//    // Check if commission plan has changed (but user role hasn't) - only for add-user page (not pending-users)
  
//   // Check if commission plan has changed (but user role hasn't) - only for add-user page (not pending-users)
//   console.log('DEBUG: Checking commission plan condition...');
//   console.log('DEBUG: org_comm_plan_id exists:', !!this.org_comm_plan_id);
//   console.log('DEBUG: userModel.comm_plan_id exists:', !!this.userModel.comm_plan_id);
//   console.log('DEBUG: commission plans different:', this.org_comm_plan_id !== this.userModel.comm_plan_id);
//   console.log('DEBUG: page is not pending-users:', this.page !== 'pending-users');
//   console.log('DEBUG: user roles are same:', this.org_user_role === this.userModel.userRole);
  
//   if (this.org_comm_plan_id && this.userModel.comm_plan_id && 
//       this.org_comm_plan_id !== this.userModel.comm_plan_id && 
//       this.page !== 'pending-users' &&
//       this.org_user_role === this.userModel.userRole) {
    
   
//     // Check if Generate New COMPAS ID checkbox is checked - FORCE this requirement
//     if (!this.isChecked) {
//       alert("Commission plan has changed. Please check 'Generate New COMPAS ID' before proceeding with the update.");
//       return; // Block the update process until checkbox is checked
//     }
//   }

//    // Only show the confirmation popup for regular updates, not for pending users
//   if (original !== current && this.page !== 'pending-users') {
//     const confirmChange = confirm("The effective date has changed. Please clear the 'Soft Termination Date' if the employee is active again. A new record will be created for this employee with the updated effective date. Do you want to continue?");
//     if (!confirmChange) {
//       return; 
//     }
//   }
//   this.saveUser();
// }
// helper: safely extract YYYY-MM from a date input value
private ym(dateVal: any): string {
  // dateVal from <input type="date"> is usually "YYYY-MM-DD"
  if (typeof dateVal === 'string' && dateVal.length >= 7) {
    return dateVal.substring(0, 7); // "YYYY-MM"
  }

  // fallback if it's a Date
  const d = new Date(dateVal);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  return `${y}-${m}`;
}

  onUpdate(): void {
     // Check if the effective date falls within a locked period first
  if (this.isFormLocked) {
  //  this.showLockedPeriodPopup();
    return;
  }
 
     // If correction mode is enabled, bypass all validations and go straight to save
  if (this.isCorrectionMode) {
    console.log('Correction mode: Bypassing all validations');
    this.saveUser();
    return;
  }
  const original = new Date(this.org_effective_date).toISOString().split('T')[0];
  const current = new Date(this.userModel.effective_date).toISOString().split('T')[0];
  const effectiveDateChanged = original !== current;
  const originalYM = this.ym(this.org_effective_date);
  const currentYM  = this.ym(this.userModel.effective_date);

  const sameMonth = originalYM === currentYM;
  if(effectiveDateChanged && this.userModel.unlock==='N' && sameMonth){
alert("same month changes not allowed since it is locked");
return;
  }
  

  // Check if user role has changed - only for add-user page (not pending-users)
  if (this.org_user_role && this.userModel.userRole && 
      this.org_user_role !== this.userModel.userRole && 
      this.page !== 'pending-users') {
    
    // Check if commission plan has been updated (must be different from original)
    const commissionPlanUpdated = this.org_comm_plan_id !== this.userModel.comm_plan_id;
    
    // All three conditions must be met: commission plan updated AND effective date changed AND Generate New COMPAS ID checked
    if (!commissionPlanUpdated && !effectiveDateChanged && !this.isChecked) {
      alert("User role has changed. Please update the commission plan, change the effective date, and check 'Generate New COMPAS ID' before proceeding.");
      return;
    } else if (!commissionPlanUpdated && !effectiveDateChanged) {
      alert("User role has changed. Please update the commission plan and change the effective date before proceeding.");
      return;
    } else if (!commissionPlanUpdated && !this.isChecked) {
      alert("User role has changed. Please update the commission plan and check 'Generate New COMPAS ID' before proceeding.");
      return;
    } else if (!effectiveDateChanged && !this.isChecked) {
      alert("User role has changed. Please change the effective date and check 'Generate New COMPAS ID' before proceeding.");
      return;
    } else if (!commissionPlanUpdated) {
      alert("User role has changed. Please update the commission plan before proceeding.");
      return;
    } else if (!effectiveDateChanged) {
      alert("User role has changed. Please change the effective date before proceeding.");
      return;
    } else if (!this.isChecked) {
      alert("User role has changed. Please check 'Generate New COMPAS ID' before proceeding.");
      return;
    }
  }

  // Check if sales channel has changed (but user role hasn't) - only for add-user page (not pending-users)
   if (this.org_sales_channel && this.userModel.sales_rep_channel && 
      this.org_sales_channel !== this.userModel.sales_rep_channel && 
      this.page !== 'pending-users' &&
      this.org_user_role === this.userModel.userRole) {
    
    // Both conditions must be met: effective date changed AND Generate New COMPAS ID checked
    if (!effectiveDateChanged && !this.isChecked) {
      alert("Sales channel has changed. Please change the effective date and check 'Generate New COMPAS ID' before proceeding with the update.");
      return;
    } else if (!effectiveDateChanged) {
      alert("Sales channel has changed. Please change the effective date before proceeding with the update.");
      return;
    } else if (!this.isChecked) {
      alert("Sales channel has changed. Please check 'Generate New COMPAS ID' before proceeding with the update.");
      return;
    }
  }

  // Only show the confirmation popup for regular updates, not for pending users
  if (original !== current && this.page !== 'pending-users') {
    const confirmChange = confirm("The effective date has changed. Please clear the 'Final Termination Date' if the employee is active again. A new record will be created for this employee with the updated effective date. Do you want to continue?");
    if (!confirmChange) {
      return; 
    }
  }
  this.saveUser();
}


  saveAfterValidate() {
    this.prepareCommissionPlanData();

       // If correction mode is enabled, always update existing record, never create new one
    if (this.isCorrectionMode) {
      console.log('Correction mode: Forcing updateUsers() to modify existing record');
      this.userModel.profileStatus = 'complete';
      this.updateUsers();
      return;
    }

    const orgEffDate = new Date(this.org_effective_date);
    const newEffDate = new Date(this.userModel.effective_date);
    console.log("orgEffDate = " + orgEffDate.getTime());
    console.log("newEffDate = " + newEffDate.getTime());

    if (this.isChecked === false) {
      this.checkboxChecked = "false";
    } else {
      this.checkboxChecked = "true";
    }

    console.log("checkboxChecked = " + this.checkboxChecked);

    if (this.page === 'pending-users') {
      console.log("Inside IF pending-users");
      this.userModel.profileStatus = 'complete';
      this.updateUsers();
    } else {
      if (orgEffDate.getTime() === newEffDate.getTime()) {
        console.log("Inside IF");

        if (this.checkboxChecked == "false") {
          console.log("Inside IF updateUsers");
          this.updateUsers();
        } else {
          console.log("Inside ELSE saveNewUser");
          this.saveNewUser();
        }
      } else {
        console.log("Inside ELSE pending-users");
        this.saveNewUser();
      }
    }


  }

  private saveNewUser() {
    console.log("Inside saveNewUser");
    const user = this.authGaurdService.loginUser()

    this.userModel.created_dt = new Date();
    this.userModel.created_by = user;
    this.userModel.profileStatus = 'complete';
    this.userModel.assc_corps = this.userModel.corps.toString();

    if (this.userModel.sales_rep_id === null || this.userModel.sales_rep_id === "") {
      this.userModel.sales_rep_id = "NA";
    }
    //console.log(this.userModel.userRole);
    if (this.userModel.effective_date === null) {
      this.sendNotification(NotificationType.ERROR, `Please select effective date`);
    } else if (this.userModel.userRole === "Sales Representative" || this.userModel.userRole === "No Access") {
      if (this.userModel.assc_corps === "" || this.userModel.assc_corps === "0" || this.userModel.assc_corps === null) {
        this.sendNotification(NotificationType.ERROR, `Please select at least one corp`);
      } else {
        this.submitNewUser(this.userModel);
      }
    } else {
      this.submitNewUser(this.userModel);
    }
  }

  private submitNewUser(addUserModel: AddUser) {
    console.log("Inside submitNewUser");
    const skipSupervisor =
      this.userModel.userRole === "ADMIN" || this.userModel.userRole === "Sales Channel Admin";

    if (addUserModel.supervisor_name == "" || addUserModel.supervisor_name == null || addUserModel.supervisor_name == undefined) {
      console.log("Inside IF");
      addUserModel.supervisor_id = 0;
    } else {
      console.log("Inside ELSE");
      let selectedOption = addUserModel.supervisor_name;
      var lastIndex = selectedOption.lastIndexOf("-");
      if (lastIndex >= 0) {
        addUserModel.supervisor_name = selectedOption.substring(0, lastIndex);
        addUserModel.supervisor_id = selectedOption.substring(lastIndex + 1);
      } else if (skipSupervisor) {
        addUserModel.supervisor_id = 0;
      }
    }

    // ADMIN and Sales Channel Admin do not require supervisor
    if (!skipSupervisor && (!addUserModel.supervisor_name || !addUserModel.supervisor_id)) {
      this.sendNotification(NotificationType.ERROR, `Please select supervisor in this format NAME-EMPLOYEEID`);
      return;
    }

    addUserModel.checkboxchecked = this.checkboxChecked;

    this.newUsers.push(addUserModel);

    console.log(this.newUsers);
    this.manageUserService.saveUser(this.newUsers)
      .subscribe(response => {
        //response = response as ErrorResponseMessage;
        this.sendNotification(NotificationType.SUCCESS, `User Added Successfully`);

        this.getPrePopulatedUserData();
        if (this.page === 'pending-users') {
          this.router.navigate(['/pending-users']);
        } else {
          this.router.navigate(['/search-users']);
        }
      }, (errorResponse: HttpErrorResponse) => {
        console.log(errorResponse);
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
      )
  }

  private updateUsers() {
    console.log("Inside updateUsers");
    //console.log(this.userModel.corps);
    if (this.userModel.corps.length >= 1) {
      this.userModel.assc_corps = this.userModel.corps.toString();
      //console.log(this.userModel.assc_corps);
    } else {
      this.userModel.assc_corps = "";
      // console.log(this.userModel.assc_corps);
    }

    this.userModel.updated_dt = new Date();
    this.userModel.updated_by = this.authGaurdService.loginUser();
    // console.log(this.userModel.supervisor_name);

    if (this.userModel.supervisor_name == "" || this.userModel.supervisor_name == null || this.userModel.supervisor_name == undefined) {
      this.userModel.supervisor_id = 0;
    } else {
      let selectedOption = this.userModel.supervisor_name;
      var lastIndex = selectedOption.lastIndexOf("-");

      // let supDetails = selectedOption.split("-");
      this.userModel.supervisor_name = selectedOption.substring(0, lastIndex);
      this.userModel.supervisor_id = selectedOption.substring(lastIndex + 1);

    }

    if (this.userModel.userRole === "ADMIN" || this.userModel.userRole === "Sales Channel Admin") {
      this.updateUser(this.userModel);
    } else {
      if (!this.userModel.supervisor_name || !this.userModel.supervisor_id) {
        this.sendNotification(NotificationType.ERROR, `Please select supervisor in this format NAME-EMPLOYEEID`);
      } else {
        if (this.userModel.userRole === "Sales Representative" || this.userModel.userRole === "No Access") {
          if (this.userModel.assc_corps === "" || this.userModel.assc_corps === "0" || this.userModel.assc_corps === null) {
            this.sendNotification(NotificationType.ERROR, `Please select at least one corp`);
          } else {
            this.updateUser(this.userModel);
            console.log("user updated", this.userModel)
          }
        } else {
          this.updateUser(this.userModel);
          console.log("user updated", this.userModel)
        }
      }
    }

  }

private updateUser(addUserModel: AddUser) {
    console.log("updateUser() called");
    console.log(addUserModel);
    console.log(this.page);
    addUserModel.pageStatus = this.page;
    console.log(addUserModel);
    // Set proper updated_by and updated_dt fields for status updates
    addUserModel.updated_by = this.authGaurdService.loginUser();
    addUserModel.updated_dt = new Date();
    // Use the new updateEmployeeStatus API for profile status changes
    // This API is specifically designed to handle inactive -> active transitions properly
    console.log("Using updateEmployeeStatus for focused status update");
    this.manageUserService.updateEmployeeStatus(addUserModel)
      .subscribe(response => {
        response = response as ErrorResponseMessage;
        this.sendNotification(NotificationType.SUCCESS, `User Updated Successfully`);
        this.getPrePopulatedUserData();
        // console.log(this.page);
        // this.manageUserService.userModel = addUserModel;
 
        if (this.page === 'pending-users') {
          this.router.navigate(['/pending-users']);
        } else {
          // Navigate back with returnFrom parameter to trigger refresh in search-users
          this.router.navigate(['/search-users'], { queryParams: { returnFrom: 'update' } });
        }
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
      )
  }

  back() {
    if (this.returnTo === 'pending-users' || this.page === 'pending-users') {
      this.router.navigate(['/pending-users']);
      return;
    }

    // Use browser/app history so Back returns to the immediate previous page elsewhere.
    if (window.history.length > 1) {
      this.location.back();
      return;
    }

    if (this.page === 'newUser') {
      this.router.navigate(['/search-users'], { queryParams: { page: 'pending-users' } });
      return;
    }

    this.router.navigate(['/search-users']);
  }

  clickedRow(e: any) {
    //this.userModel.corps =[];
    var numeric = Number(e.target.innerText);
    // console.log("hhkhhh  ", numeric);
    //var exists = msgArr.some(o => o.objectId === data.objectId);
    if (!this.userModel.corps.includes(numeric)) {
      // console.log('value is not exist', e.target.innerText)
      this.userModel.corps.push(numeric);
    }
    else if (this.userModel.corps.includes(numeric)) {
      /// console.log('value is  exist', numeric)
      this.userModel.corps.forEach((element: number, index: any) => {
        if (element == e.target.innerText) this.userModel.corps.splice(index, 1);
      });
    }
    // console.log("clickedRow =  ", this.userModel.corps);
  }

  private sendNotification(notificationType: NotificationType, message: string): void {
    if (message) {
      this.notificationService.notify(notificationType, message);
    } else {
      this.notificationService.notify(notificationType, 'An error occurred. Please try again.');
    }
  }

   onSalesRepIdChange(): void {
    // Reset the validation flag when user modifies the field
    this.isSalesRepIdInvalid = false;
  }

// Validate Sales Rep ID when user leaves the field
    onSalesRepIdBlur(): void {
    console.log('onSalesRepIdBlur() called');
    
    // Only validate if Sales Rep ID is provided and not empty
    if (!this.userModel.sales_rep_id || this.userModel.sales_rep_id.trim() === '' || this.userModel.sales_rep_id === 'NA') {
      console.log('Sales Rep ID is empty or NA, skipping validation');
      this.isSalesRepIdInvalid = false; // Reset flag
      return;
    }

    // Get current user's sc_emp_id (empty for new users)
    const currentScEmpId = this.userModel.id || '';

    console.log('Validating Sales Rep ID: ' + this.userModel.sales_rep_id + ', currentScEmpId: ' + currentScEmpId);
    
    this.manageUserService.validateSalesRepId(this.userModel.sales_rep_id, currentScEmpId).subscribe(
      (isActive: boolean) => {
        console.log('Validation result: ' + isActive);
        if (isActive) {
          // Sales Rep ID is already assigned to an active user
          this.sendNotification(NotificationType.ERROR, 'The Sales Rep ID is assigned to an Active user, please use a different Sales Rep ID');
          // Keep the invalid flag set - user must enter a different ID
          this.isSalesRepIdInvalid = true;
        } else {
          // Sales Rep ID is available
          this.isSalesRepIdInvalid = false; // Reset flag
          console.log('Sales Rep ID is available for use');
        }
      }, (errorResponse: HttpErrorResponse) => {
        console.error('Error validating Sales Rep ID:', errorResponse);
        this.isSalesRepIdInvalid = false; // Reset flag on error (allow submission)
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );
  }


  // START =====================================================================================================


  public displayFunction(distri: any) {
    // console.log("distri === " + JSON.stringify(distri));

    this.users = this.comPlansUserData.filter(distribute => distribute.comm_plan_id === distri.comm_plan_id);
    if (this.users.length > 0) {
      return this.users[0].commission_plan;
    }
    else
      return '';
    //  return this.comPlansUserData.filter(user => this._normalizeValue(user.commission_plan).includes(filterValue));
  }

  emitAdjustedData = (): void => {
    // const results: Array<string> = []
    var rest: string = "";
    // console.log("this.selectData===" + JSON.stringify(this.selectedCommplans));
    this.selectedCommplans.forEach((data: AddUser) => {
      rest = rest + data.comm_plan_id + ",";
      this.selectedCommplanIds = rest.slice(0, -1);
      this.userModel.commPlanId = this.selectedCommplanIds;
      // console.log("this.selectedCommplanIds===" + this.selectedCommplanIds);
      // results.push(data.empName);
    });
    // this.result.emit({ key: this.key, data: results });
    // console.log("this.result===" + JSON.stringify(this.result));
  };

  // removeChip = (data: AddUser): void => {
  //   this.toggleSelection(data);
  // };

  filterCommPlans() {
    this.filteredCommPlans = this.selectControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value))
    );
    // console.log(' filteredApprovalValues', this.filteredCommPlans)
  }

  private _filter(value: string): AddUser[] {
    const filterValue = this._normalizeValue(value);
    //this.filteredValues = this.approvalValueSet.filter(street => this._normalizeValue(street.name).includes(filterValue));

    return this.comPlansUserData.filter(user => this._normalizeValue(user.commission_plan).includes(filterValue));
  }

  getSupId(val: any) {

    // let selectedOption = this.userModel.supName;//val.option.value;
    // let supDetails = selectedOption.split("-");
    // this.userModel.supervisor_name = supDetails[0];
    // this.userModel.supervisor_id = Number(supDetails[1]);
  }

  // END =============================================================================================

  filter() {
    this.hidefields = false;
  }


  filterSupervisors() {
    this.filteredSupValues = this.controlSup.valueChanges.pipe(
      startWith(''),
      map(value => this._filterSup(value))
    );
  }

  private _filterSup(value: string): AddUser[] {
    const filterValue = value.toLowerCase();

    if (value && value.length >= 3) {
      this.manageCodesService.getEmpSupervisors(value)
        .subscribe((data: any) => {
          this.supervisorData = data;
          //this.filterSupervisors();
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        });
    }
    return this.supervisorData.filter(item => item.supervisor_name.toLowerCase().includes(filterValue));
  }

  filterSalesChannels() {
    this.filteredSalesChannelValues = this.controlSc.valueChanges.pipe(
      startWith(''),
      map(value => this._filterSC(value))
    );
  }
  private _filterSC(value: string): AddUser[] {
    const filterValue = this._normalizeValue(value);
    return this.salesChnlsUserData.filter(item => this._normalizeValue(item.sales_rep_channel_desc).includes(filterValue));
  }

  filterSalesRepTypes() {
    this.filteredSalesRepTypeValues = this.controlSrt.valueChanges.pipe(
      startWith(''),
      map(value => this._filterSrt(value))
    );
  }
  private _filterSrt(value: string): string[] {
    const filterValue = this._normalizeValue(value);
    return this.salesRepTypes.filter(item => this._normalizeValue(item).includes(filterValue));
  }
  private _normalizeValue(value: string): string {
    return value.toString().toLowerCase().replace(/\s/g, '');
  }

  isLastDayOfMonth(date: Date | null): boolean {
    date = date ?? new Date();
    const dayOfMonth = date.getDate();
    const lastDayOfMonth = getLastDayOfMonth(date);

    return dayOfMonth === lastDayOfMonth;
  };

  //   /**
  //  * Load calendar data to check for locked periods
  //  */
  // loadCalendarData(): void {
  //   // Try to get calendar data for the current calendar type or all types
  //   this.calendarService.getCalData().subscribe(
  //     (response: CalendarModel[]) => {
  //       this.calendarData = response;
  //       console.log('Calendar data loaded:', this.calendarData);
  //       this.checkFormLockStatus();
  //     },
  //     (errorResponse: HttpErrorResponse) => {
  //       console.log('Error loading calendar data:', errorResponse);
  //       // If we can't load calendar data, assume form is not locked
  //       this.isFormLocked = false;
  //     }
  //   );
  // }

  // /**
  //  * Check if the current effective date falls within a locked period
  //  */
  // checkFormLockStatus(): void {
  //   if (this.userModel.effective_date && this.calendarData.length > 0) {
  //     this.isFormLocked = this.calendarService.isDateInLockedPeriod(
  //       this.userModel.effective_date, 
  //       this.calendarData
  //     );
  //     console.log('Form lock status:', this.isFormLocked, 'for date:', this.userModel.effective_date);
  //   } else {
  //     this.isFormLocked = false;
  //   }
  // }

  // /**
  //  * Handle effective date changes to check lock status
  //  */
  // onEffectiveDateChange(): void {
  //   this.checkFormLockStatus();
  // }

  // /**
  //  * Show popup when user tries to update during locked period
  //  */
  // showLockedPeriodPopup(): void {
  //   const result = confirm('The cycle is closed — can we create the record with new Effective date?');
  //   if (result) {
  //     // User agreed to create with new effective date
  //     // Navigate to new user creation or clear form for new effective date
  //     this.showLockedPeriodAlert = false;
  //     // You can add logic here to handle the new record creation
  //   }
  // }

    /**
   * Toggle correction mode - when enabled, bypasses all validation rules
   */
  toggleCorrectionMode(): void {
    this.isCorrectionMode = !this.isCorrectionMode;
    
    if (this.isCorrectionMode) {
      this.correctionButtonText = "Exit Correction";
      this.correctionButtonClass = "btn btn-danger";
      console.log('Correction mode ENABLED - All validations will be bypassed');
    } else {
      this.correctionButtonText = "Correction";
      this.correctionButtonClass = "btn btn-primary";
      console.log('Correction mode DISABLED - Normal validations will apply');
    }
  }
  onLockedCycleClick(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();

    this.lockedCycleMsgVisible = true;

    setTimeout(() => {
      this.lockedCycleMsgVisible = false;
    }, 4000);
  }


}


function getLastDayOfMonth(date: Date): number {
  return new Date(date.getFullYear(), date.getMonth(), 1).getDate();
}